import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';

import { Col, Row } from 'react-bootstrap';
import { getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import CalendarSVG from 'images/svg/calendar.svg';

import LeftCaretSVG from 'images/svg/left_caret.svg';
import RightCaretSVG from 'images/svg/right_caret.svg';

import {
  SPostContainer,
  SPostMast,
  SPostTitle,
  FooterNav,
  SPostFeaturedImage,
  SPostContent,
  SPostInfoItem,
  SSectionBG,
  SPostTag,
  SPostTags,
  SFooterNavs,
} from './styles';
import SEO from 'components/seo';
import BlogSocialIcons from 'components/SocialIcons';
import { modifyHTMLContent } from '../preprocessing/post';
import { ucFirst } from '../preprocessing/page';
import CategoryName from 'components/CategoryName';
import RelatedBlogPosts from 'components/RelatedBlogPosts';
import BlogPageSidebar from 'components/BlogPageSidebar';
import SinglePostTOC from 'components/SinglePostTOC';
import { createTableOfContents } from 'utils/createTOC';

const SingleWpContentTemplate = ({
  post,
  podcast,
  nextItem,
  previousItem,
  isPodcast,
  relatedPosts,
  latestBlogposts = [],
  latestPodcasts = [],
  toc,
}) => {
  const content = isPodcast ? podcast : post;
  console.log(toc);

  const resolutions =
    content?.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData;

  const image = content.featuredImage
    ? getImage(content.featuredImage.node.localFile)
    : null;
  const modifiedContent = modifyHTMLContent(content.content, content);

  return (
    <Layout navType="dark" logoType={'light'}>
      <SEO
        title={content.seo.title}
        description={content.seo.metaDesc}
        imgSrc={image?.images?.fallback?.src}
        schemaMarkup={{
          '@type': 'NewsArticle',
          headline: content.seo.title,
          image: [resolutions?.src],
          datePublished: content.date,
          dateModified: content.modified,
          address: undefined,
          author: {
            '@type': 'Person',
            name: 'Sam Ghosh',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Oasis Living',
            logo: {
              '@type': 'ImageObject',
              url:
                'https://oasis-static-files.s3.eu-west-2.amazonaws.com/logo_blue.png',
            },
          },
        }}
      />
      <SSectionBG>
        <SPostContainer className="single-blog-post-page">
          <Row>
            <Col sm={12} md={9}>
              <Row>
                <SPostMast>
                  <section className="mb-2">
                    {!isPodcast &&
                      (content.categories.nodes.length || null) && (
                        <CategoryName
                          isPodcast={isPodcast}
                          slug={content.categories.nodes[0].slug}
                          name={content.categories.nodes[0].name}
                        />
                      )}
                  </section>
                  <section className="mb-2">
                    {[
                      //{ icon: <AuthorSVG />, text: 'John Martins' },
                      { icon: <CalendarSVG />, text: content.modified },
                      //{ icon: <CommentSVG />, text: 24 },
                    ].map(item => {
                      return (
                        <SPostInfoItem key={item.text}>
                          {item.icon}
                          {item.text}
                        </SPostInfoItem>
                      );
                    })}
                  </section>
                  <SPostTitle>{content.title}</SPostTitle>

                  <BlogSocialIcons
                    title={content.title}
                    href={
                      typeof window !== 'undefined' ? window.location.href : ''
                    }
                  />
                </SPostMast>
              </Row>
            </Col>
            <Col lg={9} className="mt-lg-5">
              <Row>
                {!isPodcast ? (
                  <Col sm="12" className="mb-3">
                    <SPostFeaturedImage
                      image={image}
                      alt={content.title}
                      isPodcast={isPodcast}
                    />
                  </Col>
                ) : null}
                {!isPodcast && toc?.items?.length && (
                  <SinglePostTOC toc={toc} />
                )}
                <Col sm="12" className="">
                  <SPostContent
                    className="single-blog-post-content"
                    dangerouslySetInnerHTML={{ __html: modifiedContent }}
                  />
                </Col>
                <Col sm="12">
                  <BlogSocialIcons
                    isFooter={true}
                    title={content.title}
                    href={
                      typeof window !== 'undefined' ? window.location.href : ''
                    }
                  />
                </Col>
                <Col sm="12">
                  {/* Display the post tags */}
                  {(content.tags.nodes.length || null) && (
                    <SPostTags>
                      {content.tags.nodes.map(tag => {
                        return (
                          <SPostTag
                            key={tag.name}
                            to={`/blog/tags/${tag.slug}/1/`}
                          >
                            {ucFirst(tag.name)}
                          </SPostTag>
                        );
                      })}
                    </SPostTags>
                  )}
                </Col>

                <Col lg={12}>
                  <SFooterNavs>
                    <FooterNav xs={6} className="previous-nav">
                      {previousItem && previousItem.node && (
                        <Link to={`/blog/${previousItem.node.slug}`}>
                          <div className="title">
                            <LeftCaretSVG /> PREVIOUS POST
                          </div>
                          <div className="link">{previousItem.node.title}</div>
                        </Link>
                      )}
                    </FooterNav>

                    <FooterNav xs={6} className="next-nav">
                      {nextItem && nextItem.node && (
                        <Link to={`/blog/${nextItem.node.slug}`}>
                          <div className="title">
                            NEXT POST <RightCaretSVG />
                          </div>
                          <div className="link">{nextItem.node.title}</div>
                        </Link>
                      )}
                    </FooterNav>
                  </SFooterNavs>
                </Col>
              </Row>
            </Col>
            <Col lg={3} className="mt-lg-5">
              <BlogPageSidebar
                isPodcast={isPodcast}
                latestBlogposts={latestBlogposts}
                latestPodcasts={latestPodcasts}
              />
            </Col>
          </Row>
        </SPostContainer>
      </SSectionBG>

      <RelatedBlogPosts posts={relatedPosts} isPodcast={isPodcast} />
    </Layout>
  );
};

SingleWpContentTemplate.propTypes = {
  post: PropTypes.object,
  podcast: PropTypes.object,
  isPodcast: PropTypes.bool,
  nextItem: PropTypes.object,
  relatedPosts: PropTypes.array,
  toc: PropTypes.array,
  latestBlogposts: PropTypes.array,
  latestPodcasts: PropTypes.array,
  previousItem: PropTypes.object,
};

export default SingleWpContentTemplate;
